import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { State } from '@progress/kendo-data-query';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { EmployeesService } from 'src/app/shared/services/employees/employees.service';
import { Utility } from 'src/app/shared/utility';

@Component({
  selector: 'app-pending-enrollments',
  templateUrl: './pending-enrollments.component.html',
  styleUrls: ['./pending-enrollments.component.css']
})
export class PendingEnrollmentsComponent implements OnInit {
  gridView = [];
  operators: any;
  config: any;
  removeRecord: any;
  dataLoading = true;
  loading: boolean;
  deleteEnrollmentDialog: boolean;
  state: State = {
    skip: 0,
    take: 13,
    sort: []
  };
  @Output() loadPendingEnrollment: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private employeesService: EmployeesService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit(): void {
    this.operators = this.authService.getAccessOperations(2);
    this.config = this.readConfigService.getEnrollmentMemberText();
    this.getPendingEnrollmentsData();
  }

  getPendingEnrollmentsData() {
    this.gridView = [];
    const inputData = { userInfo: this.usersService.UserInfo(), tabName: 'InProgress' };
    this.employeesService.getPendingEnrollData(inputData).subscribe(response => {
      if (response && response.statusCode === 200) {
        const orgValue = JSON.parse(this.authService.decryptText(Utility.removeQuotes(sessionStorage.getItem('current_user'))));
        response.data.forEach((element: any) => {
          element.lastFourSSN = element.ssn.substr(5);
          element.isAuthorizedOwner = (element.ownerID === Number(orgValue.Id));
          this.gridView.push(element);
        });
      } else if (response && response.statusCode === 204) {
        this.gridView = [];
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.dataLoading = false;
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.dataLoading = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  assignToYourself(data: any) {
    this.dataLoading = true;
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      enrollmentID: data.id,
    };
    this.employeesService.updateEnrollmentRecordOwner(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.notificationService.setUpNotification({ message: response.message, success: true });
      } else {
        this.notificationService.setUpNotification({ message: response.message, success: false });
      }
      this.getPendingEnrollmentsData();
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.dataLoading = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  editHandler(editEvent: any) {
    this.loadPendingEnrollment.emit(editEvent);
  }

  removeHandler(removeEvent: any) {
    this.removeRecord = removeEvent;
    this.deleteEnrollmentDialog = true;
  }

  deleteEnrollmentRecord() {
    this.loading = true;
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      enrollmentId: this.removeRecord.dataItem.id
    };
    this.employeesService.deletePendingEnrollRecord(inputData).subscribe(response => {
      if (response && response.statusCode === 200) {
        this.dataLoading = true;
        this.getPendingEnrollmentsData();
        this.notificationService.setUpNotification({ message: response.message, success: true });
      } else {
        this.notificationService.setUpNotification({ message: response.message, success: false });
      }
      this.deleteEnrollmentDialog = false;
      this.notificationService.setUpLoading(false);
      this.loading = false;
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.loading = false;
        this.deleteEnrollmentDialog = false;
        this.dataLoading = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

}
